import React, { FC } from 'react';
import { formatPhoneNumber } from 'Shared/utils';
import { PartnerRecordType } from 'Admin/services/endpoints/PostAttributionTypeahead';

import styles from './styles.module.css';

type AgencyDetailsProps = { agency?: PartnerRecordType | null };

const formatAddress = (address: PartnerRecordType['address']): string => {
  const { lineOne, lineTwo, city, state, zip } = address;

  const addressAndCityStrings = [lineOne, lineTwo, city].filter(
    (item) => !!item
  );
  const stateAndZipString = [state, zip].filter((item) => !!item).join(' ');

  // avoid trailing commas by not adding a blank state and zip string
  if (stateAndZipString) {
    addressAndCityStrings.push(stateAndZipString);
  }

  return addressAndCityStrings.join(', ');
};

const hasAddress = (address: PartnerRecordType['address']) =>
  Object.values(address).some((value) => !!value);

export const AgencyDetails: FC<AgencyDetailsProps> = ({ agency }) => {
  if (!agency) return null;
  return (
    <div className={styles.wrapper} data-testid="agency-details">
      <div className={styles.heading}>Agency Details</div>
      <div>{agency.name}</div>
      {hasAddress(agency.address) && (
        <div data-testid="agency-address">{formatAddress(agency.address)}</div>
      )}
      {agency.phone && (
        <div data-testid="agency-phone">{formatPhoneNumber(agency.phone)}</div>
      )}
      {agency.parent && (
        <div className={styles.secondary} data-testid="agency-parent">
          Sub-agency of {agency.parent.name}
        </div>
      )}
    </div>
  );
};
